import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './PolicyPage.css';

// 새 이용약관 시행일 (개인정보처리방침과 동일)
const NEW_TERMS_EFFECTIVE_DATE = new Date('2025-12-18');

const TermsOfService = () => {
  const [searchParams] = useSearchParams();
  const now = new Date();
  
  // ?preview=new 쿼리 파라미터로 미리보기 가능
  const isPreviewMode = searchParams.get('preview') === 'new';
  const isNewTermsEffective = isPreviewMode || now >= NEW_TERMS_EFFECTIVE_DATE;

  return isNewTermsEffective ? <NewTermsOfService isPreview={isPreviewMode} /> : <CurrentTermsOfService />;
};

// ============================================================
// 새 이용약관 (2025-12-18 이후 적용)
// AI 서비스 특례 조항 포함
// ============================================================
const NewTermsOfService = ({ isPreview = false }) => {
  return (
    <div className="policy-page">
      <main className="policy-document">
        <header className="policy-header">
          <h1 className="policy-title">왓퀴즈 이용약관</h1>
        </header>

        {/* 미리보기 모드 배너 */}
        {isPreview && (
          <div className="policy-preview policy-card policy-card--danger">
            <p>
              미리보기 모드 - 이 약관은 2025년 12월 18일부터 정식 적용됩니다
            </p>
          </div>
        )}

        <div className="policy-effective">
          <strong>
            시행일: 2025년 12월 18일 | 최종 개정일: 2026년 9월 10일
          </strong>
        </div>

        <PolicySection title="제1조 (목적)">
          <p>이 약관은 플랙티컬 주식회사(이하 "회사")가 제공하는 왓퀴즈 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
        </PolicySection>

        <PolicySection title="제2조 (정의)">
          <ol>
            <li>"서비스"란 회사가 제공하는 AI 기반 퀴즈 생성, 학습지 생성, 생활기록부 작성 지원, AI 채팅 등의 교육 관련 서비스를 의미합니다.</li>
            <li>"이용자"란 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
            <li>"회원"이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</li>
            <li>"Pro 구독"이란 기간제 결제를 통해 모든 서비스를 제한 없이 이용할 수 있는 유료 서비스를 의미합니다.</li>
            <li><strong>"AI 서비스"</strong>란 기계 학습, 딥러닝, 생성형 AI 모델 등을 활용하여 텍스트, 데이터 분석 결과 등을 생성하거나 제공하는 기능을 의미합니다.</li>
            <li><strong>"입력 데이터(Input)"</strong>란 회원이 AI 서비스를 이용하기 위해 입력하는 텍스트, 파일 등의 모든 데이터를 의미합니다.</li>
            <li><strong>"AI 결과물(Output)"</strong>이란 입력 데이터를 바탕으로 AI 서비스가 생성하여 회원에게 제공하는 일체의 결과물을 의미합니다.</li>
            <li><strong>"학교생활기록 검사 자료"</strong>란 교사가 학생 지도 및 학교생활기록 검수를 위해 검사기에 직접 입력하거나 첨부한 학교생활기록 문장, 학생 이름 및 검사 결과를 의미합니다.</li>
          </ol>
        </PolicySection>

        <PolicySection title="제3조 (회원가입)">
          <p>① 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</p>
          <p>② 회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다:</p>
          <ul>
            <li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
            <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
            <li>기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
          </ul>
        </PolicySection>

        <PolicySection title="제4조 (서비스 이용)">
          <p>① 회사는 다음과 같은 서비스를 제공합니다:</p>
          <ul>
            <li>AI 퀴즈 생성 서비스</li>
            <li>자유형 학습지 생성 서비스</li>
            <li>생활기록부 작성 지원 서비스</li>
            <li>생활기록부 기재요령 검사 및 수정 지원 서비스</li>
            <li>AI 채팅 서비스</li>
          </ul>
          <p>② 서비스 이용 시 회원은 관련 법령, 이 약관의 규정, 서비스 이용안내 및 주의사항을 준수하여야 합니다.</p>
        </PolicySection>

        {/* AI 서비스 특례 조항 - 신설 */}
        <PolicySection title="제5조 (AI 서비스의 성격 및 기술적 한계)">
          <div className="policy-card policy-card--warning">
            <p><strong>AI 서비스 이용 시 유의사항</strong></p>
            <p>
              AI 서비스는 확률적 모델에 기반하여 작동하므로, 생성된 결과물의 정확성이 보장되지 않습니다. 
              회원은 AI 결과물을 반드시 검토 후 사용하시기 바랍니다.
            </p>
          </div>
          
          <p>① <strong>확률적 생성:</strong> 회원은 AI 서비스가 확률적 모델에 기반하여 작동하므로, 동일한 입력에 대해서도 매번 다른 결과물이 생성될 수 있음을 이해하고 이에 동의합니다.</p>
          <p>② <strong>정확성 미보증:</strong> 회사는 AI 서비스가 생성하는 정보의 정확성, 완전성, 신뢰성, 최신성, 적합성을 보증하지 않습니다. AI 결과물에는 사실과 다른 정보가 포함될 수 있습니다.</p>
          <p>③ <strong>검증 책임:</strong> 회원은 AI 결과물을 교육 현장 등에서 사용하기 전에 반드시 내용을 검토하고 필요시 수정하여야 하며, 검증 없이 사용한 결과에 대한 책임은 회원에게 있습니다.</p>
          <p>④ <strong>전문가 자문 대체 불가:</strong> AI 서비스가 제공하는 정보는 법률적, 의학적, 재무적 조언이 아니며, 해당 분야 전문가의 조언을 대체할 수 없습니다.</p>
          <p>⑤ <strong>학교생활기록 최종 검토:</strong> 생활기록부 관련 AI 결과물은 교사의 관찰·평가와 기재요령 확인을 돕는 초안 또는 수정 제안입니다. 회원은 학생의 실제 수행과 무관한 허위·과장 내용이 없는지 확인하고, AI 결과물을 그대로 입력하지 않은 채 최종 내용을 직접 검토·확정해야 합니다.</p>
        </PolicySection>

        <PolicySection title="제6조 (지식재산권 및 데이터 활용)">
          <p>① <strong>입력 데이터의 권리:</strong> 회원이 입력한 입력 데이터의 저작권은 원칙적으로 회원에게 귀속됩니다. 회원은 입력 데이터가 제3자의 저작권, 초상권, 개인정보 등을 침해하지 않음을 보증하며, 이에 대한 법적 책임은 회원이 부담합니다.</p>
          <p>② <strong>AI 결과물의 이용:</strong> 회사는 회원이 본 약관을 준수하는 것을 조건으로, AI 결과물에 대해 회사가 가질 수 있는 권리를 회원에게 양도합니다. 회원은 AI 결과물을 자유롭게 수정, 편집, 활용할 수 있습니다.</p>
          <p>③ <strong>서비스 제공을 위한 제한적 처리:</strong> 회원은 요청한 AI 기능 제공, 결과 전송, 보안 유지 및 회원이 선택한 기록 보관을 위해 필요한 범위에서 회사가 입력 데이터와 AI 결과물을 저장, 복제, 처리하는 것을 허락합니다. 회사는 학교생활기록 검사 자료를 입시 상담, 유료 자료 제작, 광고, 제3자 판매 또는 회사·AI 제공사의 모델 학습 목적으로 이용하지 않습니다. 업로드한 원본 파일 자체는 별도 파일로 보관하지 않으며, 작성 중인 검사 초안은 연락처 등 개인정보를 마스킹한 형태로 기록될 수 있습니다.</p>
          <p>④ <strong>저작권 불명확성:</strong> 현행법상 AI 생성물의 저작권 인정 여부가 불명확하므로, 회사는 제3자가 AI 결과물을 무단으로 사용하는 것에 대해 배타적 권리를 행사하지 못할 수 있음을 회원은 인지합니다.</p>
        </PolicySection>

        <PolicySection title="제7조 (회원의 의무 및 금지행위)">
          <p>① 이용자는 다음 행위를 하여서는 안 됩니다:</p>
          <ul>
            <li>신청 또는 변경시 허위 내용의 등록</li>
            <li>타인의 정보 도용</li>
            <li>회사 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
            <li>기타 법령이나 선량한 풍속 기타 사회질서에 반하는 행위</li>
          </ul>
          
          <p>② <strong>AI 서비스 관련 금지행위:</strong> 회원은 AI 서비스를 이용하여 다음 각 호의 행위를 하여서는 안 되며, 이를 위반할 경우 회사는 사전 통지 없이 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.</p>
          <ul>
            <li><strong>위법 콘텐츠 생성:</strong> 현행 법령을 위반하거나, 타인의 명예를 훼손하거나, 외설적·폭력적인 콘텐츠를 고의로 생성하는 행위</li>
            <li><strong>기망 행위:</strong> AI 결과물을 마치 인간이 창작한 것처럼 타인을 기망하거나 오인하게 하는 행위</li>
            <li><strong>역공학 및 경쟁 모델 개발:</strong> AI 서비스를 역설계하거나, AI 결과물을 대량으로 추출하여 경쟁하는 인공지능 모델을 개발하거나 학습시키는 행위</li>
            <li><strong>보안 우회 시도:</strong> AI의 보안 필터링을 우회하거나, AI 시스템의 내부 명령어 및 기밀 정보를 탈취하려는 행위</li>
          </ul>

          <p>③ <strong>학교생활기록 관련 금지행위:</strong> 회원은 「초·중등교육법」 제25조의2를 포함한 관계 법령에 따라 학교생활기록을 취득하여 영업 목적으로 거래하거나 이용해서는 안 됩니다. 다음 행위는 금지됩니다.</p>
          <ul>
            <li>학교생활기록을 구매·판매·재판매하거나 유료 입시 상담, 합격 예측, 지원 전략 수립에 이용하는 행위</li>
            <li>학교생활기록을 유료 강의·자료, 홍보, 수강생 모집, AI 학습 데이터 또는 제3자 대상 서비스 제작에 이용하는 행위</li>
            <li>담당 교사의 학생 지도·기록 작성 및 검수 목적을 벗어나 타인의 학교생활기록을 수집·처리하는 행위</li>
            <li>최종 확정된 학교생활기록부 또는 공식 발급본을 검사기에 업로드하는 행위</li>
          </ul>
          <p>④ 생활기록부 작성·검사 기능은 교사의 학생 지도와 기록 업무를 보조하기 위한 서비스입니다. 회사는 제3항 위반이 확인되거나 합리적으로 의심되는 경우 관련 자료의 처리를 중단하고 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.</p>

          <p>⑤ <strong>서비스 콘텐츠의 무단 수집 및 재배포 금지:</strong> 회원은 회사가 제공하는 교육과정 성취기준 데이터베이스, 검색 결과, AI 생성물 등 서비스 내 콘텐츠를 회사의 사전 동의 없이 자동화된 수단(크롤링·스크래핑·봇 등)으로 수집하거나, 이를 복제·재배포·판매하거나 경쟁 서비스 구축에 이용해서는 안 됩니다. 회사는 이를 위반한 경우 서비스 이용을 제한하거나 법적 조치를 취할 수 있습니다. 단, 회원이 자신의 교육 활동을 위해 서비스 화면에서 통상적으로 열람·인용하는 것은 제외합니다.</p>
        </PolicySection>

        <PolicySection title="제8조 (Pro 구독 서비스)">
          <div className="policy-card policy-card--success">
            <p><strong>Pro 구독 혜택</strong></p>
            <ul>
              <li>모든 서비스 제한 없이 이용 가능</li>
              <li>모든 AI 모델 사용 가능 (GPT, Claude, Gemini 등)</li>
              <li>우선 고객 지원</li>
            </ul>
          </div>
          <p>① 구독 요금은 선택한 기간에 대해 일회성 결제되며, 자동 갱신되지 않습니다.</p>
          <p>② 구독 요금 및 플랜은 서비스 내 안내를 따릅니다.</p>
        </PolicySection>

        <PolicySection title="제9조 (결제 및 환불)">
          <p>① 환불 정책 (「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 준수):</p>
          <ul>
            <li><strong>구독 후 7일 이내:</strong> 사용 이력과 무관하게 100% 전액 환불 (마이페이지 → 구독 관리 → 환불 요청 시 자동 처리)</li>
            <li><strong>구독 후 7일 경과:</strong> 마이페이지 자동 환불 불가. AI 서비스는 이용 시 즉시 외부 AI API 비용이 발생하는 디지털 콘텐츠로 「전자상거래법」 제17조 제2항 제5호에 따라 청약철회가 제한될 수 있으나, 회사 귀책사유·서비스 장애·명백한 오류 등 특별한 사정이 있는 경우 angel@plactical.com으로 문의하시면 사안별로 검토합니다.</li>
            <li><strong>환불 처리 기간:</strong> 신청일로부터 3영업일 이내 (지연 시 「전자상거래법」 제18조에 따른 연 20% 지연이자 적용)</li>
          </ul>
          <p>② 환불 금액 산정에 있어 사용량 기반 차감 또는 건당 단가표는 적용하지 않습니다. 단, 매크로·계정 공유·반복 환불·단기 집중 이용 후 환불 등 오남용으로 객관적으로 인정되는 경우에는 별도의 환불 정책에 따라 제한될 수 있습니다.</p>
          <p>③ 환불의 상세 기준 및 제외 사항은 <a href="/refund-policy">환불 정책</a>에 따릅니다.</p>
        </PolicySection>

        <PolicySection title="제10조 (면책 조항)">
          <p>① 회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지, AI 모델 제공업체의 API 장애 등 불가항력적인 사유로 인해 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.</p>
          <p>② 회사는 AI 결과물이 제3자의 지식재산권을 침해하지 않음을 보증하지 않습니다. 회원이 생성한 AI 결과물로 인해 제3자와 분쟁이 발생할 경우, 회원은 자신의 비용과 책임으로 해결하여야 합니다.</p>
          <p>③ 회사는 AI 결과물의 정확성, 완전성, 적법성을 보증하지 않으며, 회원이 AI 결과물을 활용하여 내린 의사결정의 결과에 대해 책임을 지지 않습니다.</p>
        </PolicySection>

        <PolicySection title="제11조 (약관의 효력 및 변경)">
          <p>① 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지함으로써 효력을 발생합니다.</p>
          <p>② 회사는 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</p>
          <p>③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 적용일자 7일 이전부터 공지합니다.</p>
        </PolicySection>

        <PolicySection title="부칙">
          <p>① 이 약관은 2025년 12월 18일부터 시행되며, 2026년 4월 25일 제9조(결제 및 환불)가 개정되었습니다. 학교생활기록 처리 및 금지행위 관련 개정사항은 2026년 7월 29일부터 적용됩니다. 서비스 콘텐츠의 무단 수집 및 재배포 금지 관련 개정사항은 2026년 9월 10일부터 적용됩니다.</p>

          <div className="policy-card policy-card--info">
            <p>
              ② 주요 변경사항 (2025년 12월 18일):<br/>
              • <strong>AI 서비스 정의 추가</strong> - 입력 데이터, AI 결과물 등 용어 정의<br/>
              • <strong>AI 서비스 기술적 한계 고지</strong> - 정확성 미보증, 검증 책임 명시<br/>
              • <strong>지식재산권 조항 신설</strong> - AI 결과물의 권리 관계 명확화<br/>
              • <strong>AI 관련 금지행위 추가</strong> - 위법 콘텐츠 생성, 역공학 금지 등<br/>
              • <strong>면책 조항 강화</strong> - AI 서비스 관련 면책 사항 명시
            </p>
          </div>

          <div className="policy-card policy-card--success">
            <p>
              ③ 주요 변경사항 (2026년 4월 25일 — 제9조 단순화 개정):<br/>
              • <strong>7일 이내 100% 자동 환불 보장</strong> - 사용 이력과 무관하게 결제 후 7일 이내 마이페이지에서 즉시 환불<br/>
              • <strong>사용량 기반 차감 환불 폐지</strong> - "기간"과 "사용량" 중 더 높은 비율로 차감하는 공식 제거<br/>
              • <strong>건당 단가표 폐지</strong> - 환불 산정에서 AI 생성 건당 단가를 사용하지 않음<br/>
              • <strong>위약금 10% 폐지</strong> - 7일 이내 환불 시 위약금 부과 없음<br/>
              • <strong>7일 초과 처리 명료화</strong> - 자동 환불 불가 / 회사 귀책 등 특별 사정은 별도 문의<br/>
              • 본 개정은 회원의 청약철회권을 더 두텁게 보장하는 방향이므로 즉시 시행하며, 시행 사실을 <a href="/help/notice/refund-policy-update-2026-04">공지사항</a>에 게시합니다.
            </p>
          </div>

          <div className="policy-card policy-card--info">
            <p>
              ④ 주요 변경사항 (2026년 7월 29일 — 학교생활기록 보호):<br/>
              • <strong>목적 제한 명확화</strong> - 교사의 학생 지도·기록 작성 및 검수 보조 목적<br/>
              • <strong>상업적 이용 금지 반영</strong> - 입시 상담, 거래, 유료 자료·AI 학습 데이터 활용 금지<br/>
              • <strong>개인정보 마스킹</strong> - 작성 중인 검사 초안의 연락처 등 개인정보를 가려서 처리<br/>
              • <strong>원본 파일 미보관</strong> - 검사에 업로드한 파일 자체는 별도 파일로 저장하지 않음<br/>
              • <strong>교사 최종 검토 원칙</strong> - AI 결과물을 그대로 입력하지 않고 실제 수행 및 기재요령 확인<br/>
              • 자세한 내용은 <a href="/help/notice/saenggibu-commercial-use-law-2026">법 개정 대응 안내</a>에서 확인할 수 있습니다.
            </p>
          </div>

          <div className="policy-card policy-card--info">
            <p>
              ⑤ 주요 변경사항 (2026년 9월 10일 — 서비스 콘텐츠 보호):<br/>
              • <strong>무단 수집 금지</strong> - 성취기준 데이터베이스, 검색 결과, AI 생성물 등을 크롤링·스크래핑·봇 등 자동화된 수단으로 수집하는 행위 금지<br/>
              • <strong>복제·재배포·판매 금지</strong> - 회사의 사전 동의 없이 서비스 내 콘텐츠를 복제·재배포·판매하거나 경쟁 서비스 구축에 이용하는 행위 금지<br/>
              • <strong>위반 시 조치</strong> - 이용 제한 및 법적 조치 가능<br/>
              • <strong>통상적 이용 제외</strong> - 회원이 자신의 교육 활동을 위해 서비스 화면에서 통상적으로 열람·인용하는 것은 허용
            </p>
          </div>

          <p>⑥ 이전의 이용약관은 아래에서 확인하실 수 있습니다.</p>
          <ul>
            <li><a href="/help/notice/terms-of-service-previous-2024-12">2024. 12. 20 ~ 2025. 12. 17 적용 약관</a></li>
          </ul>
        </PolicySection>

        <PolicyTermsFooter />
      </main>
    </div>
  );
};

const PolicySection = ({ title, children }) => (
  <section className="policy-section">
    <h2>{title}</h2>
    {children}
  </section>
);

const PolicyTermsFooter = () => (
  <nav className="policy-related" aria-label="관련 정책">
    <div className="policy-related-links">
      <a className="policy-link" href="/company-info">회사정보</a>
      <a className="policy-link" href="/privacy-policy">개인정보처리방침</a>
      <a className="policy-link" href="/refund-policy">환불정책</a>
    </div>
  </nav>
);

// ============================================================
// @deprecated 2026-04-25
// 본 컴포넌트는 NEW_TERMS_EFFECTIVE_DATE(2025-12-18) 이전 버전입니다.
// 현재 시스템 시각은 항상 시행일 이후이므로 실사용자에게 노출되지 않는 dead code이며,
// 약관 변경 이력은 HelpCenterPage notices(/help/notice/terms-of-service-previous-2024-12)
// 에서도 별도로 보존됩니다. 향후 별도 정리 시점에 제거할 수 있습니다.
// ============================================================
// 현재 이용약관 (2025-12-18 이전)
// ============================================================
const CurrentTermsOfService = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      padding: 'clamp(1rem, 4vw, 2rem)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: 'clamp(1.5rem, 5vw, 3rem)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        lineHeight: 1.7
      }}>
        <h1 style={{
          fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
          fontWeight: '700',
          color: '#1a202c',
          marginBottom: '2rem',
          textAlign: 'center'
        }}>
          왓퀴즈 이용약관
        </h1>

        {/* 변경 예정 안내 배너 */}
        <div style={{
          backgroundColor: '#fef3c7',
          padding: '1rem 1.5rem',
          borderRadius: '12px',
          marginBottom: '1.5rem',
          border: '1px solid #fde68a'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#92400e',
            margin: 0,
            lineHeight: 1.6
          }}>
            <strong>이용약관 변경 예정 안내</strong><br/>
            AI 서비스 관련 조항 추가로 2025년 12월 18일부터 변경된 이용약관이 적용됩니다. 
            <a href="/help" style={{ color: '#b45309', marginLeft: '4px' }}>자세히 보기</a>
          </p>
        </div>

        <div style={{
          backgroundColor: '#f0f4ff',
          padding: '1.5rem',
          borderRadius: '12px',
          marginBottom: '2rem',
          border: '1px solid #c7d2fe'
        }}>
          <p style={{
            fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
            color: '#3730a3',
            margin: 0,
            textAlign: 'center',
            fontWeight: '600'
          }}>
            시행일: 2024년 12월 20일 | 최종 개정일: 2024년 12월 20일
          </p>
        </div>

        <Section title="제1조 (목적)">
          <p>이 약관은 플랙티컬 주식회사(이하 "회사")가 제공하는 왓퀴즈 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
        </Section>

        <Section title="제2조 (정의)">
          <ol style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>"서비스"란 회사가 제공하는 AI 기반 퀴즈 생성, 학습지 생성, 수행평가 자료 생성, AI 채팅 등의 교육 관련 서비스를 의미합니다.</li>
            <li style={{ marginBottom: '0.5rem' }}>"이용자"란 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
            <li style={{ marginBottom: '0.5rem' }}>"회원"란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</li>
            <li style={{ marginBottom: '0.5rem' }}>"Pro 구독"이란 3개월, 6개월, 12개월 단위 기간제 결제를 통해 모든 서비스를 제한 없이 이용할 수 있는 유료 서비스를 의미합니다.</li>
          </ol>
        </Section>

        <Section title="제3조 (회원가입)">
          <p>① 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</p>
          <p>② 회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.</p>
        </Section>

        <Section title="제4조 (서비스 이용)">
          <p>① 회사는 다음과 같은 서비스를 제공합니다:</p>
          <ul style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>AI 퀴즈 생성 서비스</li>
            <li style={{ marginBottom: '0.5rem' }}>자유형 학습지 생성 서비스</li>
            <li style={{ marginBottom: '0.5rem' }}>수행평가 자료 생성 서비스</li>
            <li style={{ marginBottom: '0.5rem' }}>AI 선생님 채팅 서비스</li>
            <li style={{ marginBottom: '0.5rem' }}>생활기록부 작성 지원 서비스</li>
          </ul>
        </Section>

        <Section title="제5조 (Pro 구독 서비스)">
          <p>① 3개월 플랜: 60,000원 (월 20,000원)</p>
          <p>② 6개월 플랜: 110,000원 (월 18,333원)</p>
          <p>③ 12개월 플랜: 200,000원 (월 16,667원)</p>
          <p>④ 구독 요금은 선택한 기간에 대해 일회성 결제되며, 자동 갱신되지 않습니다.</p>
        </Section>

        <Section title="제6조 (결제 및 환불)">
          <p>① 환불 정책 (전자상거래법 제17조 준수):</p>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>구독 후 7일 이내: 100% 전액 환불</li>
            <li style={{ marginBottom: '0.5rem' }}>구독 후 7일 경과: 사용하지 않은 기간 일할 계산 환불</li>
          </ul>
        </Section>

        <Section title="제7조 (회사의 의무)">
          <p>① 회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 지속적이고 안정적으로 서비스를 제공하는데 최선을 다하여야 합니다.</p>
        </Section>

        <Section title="제8조 (회원의 의무)">
          <p>① 이용자는 허위 내용의 등록, 타인의 정보 도용, 저작권 침해 등의 행위를 하여서는 안 됩니다.</p>
        </Section>

        <Section title="제9조 (저작권의 귀속)">
          <p>① 회사가 작성한 저작물에 대한 저작권은 회사에 귀속합니다.</p>
          <p>② 이용자가 서비스를 통해 생성한 콘텐츠에 대한 저작권은 이용자에게 귀속됩니다.</p>
        </Section>

        <Section title="부칙">
          <p>① 이 약관은 2024년 12월 20일부터 적용됩니다.</p>
        </Section>

        <TermsFooter />
      </div>
    </div>
  );
};

// 공통 컴포넌트
const Section = ({ title, children }) => (
  <section style={{ marginBottom: '2.5rem' }}>
    <h2 style={{
      fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
      fontWeight: '600',
      color: '#2d3748',
      marginBottom: '1rem',
      borderBottom: '2px solid #3182f6',
      paddingBottom: '0.5rem'
    }}>
      {title}
    </h2>
    <div style={{
      fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
      color: '#4a5568'
    }}>
      {children}
    </div>
  </section>
);

const TermsFooter = () => (
  <div style={{
    marginTop: '3rem',
    padding: '2rem 0',
    borderTop: '1px solid #e2e8f0',
    textAlign: 'center'
  }}>
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      flexWrap: 'wrap'
    }}>
      <a href="/company-info" style={{ color: '#3182f6', textDecoration: 'none', fontWeight: '500' }}>회사정보</a>
      <a href="/privacy-policy" style={{ color: '#3182f6', textDecoration: 'none', fontWeight: '500' }}>개인정보처리방침</a>
      <a href="/refund-policy" style={{ color: '#3182f6', textDecoration: 'none', fontWeight: '500' }}>환불정책</a>
    </div>
  </div>
);

export default TermsOfService;
